import { TypographyComponent } from "@gx1/gx-ui-common";
import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import ErrorBanner from "../../../../ui/error-banner/error-banner.component";
import { LoginFormContext } from "../login-form.context";
import styles from "./form-header.module.scss";

const FormHeader = () => {
  const { t } = useTranslation();
  const { errorText } = useContext(LoginFormContext);

  return (
    <Fragment>
      <header className={styles.loginHeading}>
        <div className={styles.headingWrapper}>
          <TypographyComponent styling={"h5"} boldness={"semi"} element={"h2"} color={"grey9"}>
            {t("Access Gartner BuySmart")}
          </TypographyComponent>
          <TypographyComponent rootClassName={styles.subTitle} boldness={"regular"} styling={"p-sm"} element={"p"} color="grey9">
            {t("Use your existing Gartner.com username and password.")}
          </TypographyComponent>
        </div>
      </header>
      {Boolean(errorText) && <ErrorBanner message={errorText as string} />}
    </Fragment>
  );
};

export default FormHeader;
